import React from 'react';
import {Icon, Text} from '@gravity-ui/uikit';
import {IconData} from '@gravity-ui/uikit';
import classNames from 'classnames';
import styles from './SideBar.module.scss';

export interface SideBarItem {
  text: string;
  icon: IconData;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

interface SideBarProps {
  items: SideBarItem[];
}

export const SideBar = ({items}: SideBarProps) => {
  return (
    <>
      {items.map((item, index) => (
        <div
          key={index}
          className={classNames(styles.sideBarItem, {
            [styles.sideBarItemCurrent]: item.active,
            [styles.sideBarItemInactive]: item.disabled,
          })}
          onClick={item.onClick}>
          <Icon data={item.icon} size={18} />
          <Text variant={'body-1'}>{item.text}</Text>
        </div>
      ))}
    </>
  );
};
